export enum MismatchType {
  /** there is no mismatches */
  NoMismatch,
  /** overall is needs repair but all items are ok */
  NeedsRepair,
  /** overall is ok but has some items to repair */
  AllItemsOk
}
